import { types } from 'mobx-state-tree';


const LOCK_STATES = {
    UNLOCKED: 'unlocked',
    SUBMITTED: 'submitted',
    SENDING: 'sending',
    ERROR: 'error',
    PULLING: 'pulling',
    SYNCED: 'synced',
};

const LockStateEnum = types.enumeration('LockState', Object.values(LOCK_STATES));

export {
    LockStateEnum,
};
export default LOCK_STATES;
